export function removeDotBeginningOfPath(files = []) {
    return files.map((file) => {
        return {
            ...file,
            relativePath: file.relativePath.replace(/^\.\//, ''),
        };
    });
}
//# sourceMappingURL=removeDotBeginningOfPath.js.map